// src/lib/socket.ts
import { io } from 'socket.io-client';

const configuredApiUrl =
  import.meta.env.VITE_API_BASE_URL || 'https://api.theone-myanmar.com';

// REST URLs may include a prefix such as /v1; the gateway uses the server origin.
const BACKEND_URL = new URL(configuredApiUrl).origin;

console.info('[socket] configured URL:', BACKEND_URL);

export const socket = io(BACKEND_URL, {
  autoConnect: false, // Don't connect until user logs in
});

socket.on('connect_error', (error) => {
  console.error('[socket] connect_error:', error.message, error);
});

socket.on('disconnect', (reason) => {
  console.warn('[socket] disconnected:', reason);
});